import api from "../core/http";

export const getCommunityHub = (timezone) =>
  api
    .get("/v1/community", { params: timezone ? { timezone } : undefined })
    .then((res) => res.data);

export const getCommunityBookClub = () =>
  api.get("/v1/community/book-club").then((res) => res.data);

export const joinCommunityBookClub = () =>
  api.post("/v1/community/book-club/join").then((res) => res.data);

export const leaveCommunityBookClub = () =>
  api.delete("/v1/community/book-club/leave").then((res) => res.data);

export const addBookClubComment = (threadId, body, parentId) =>
  api
    .post(`/v1/community/threads/${threadId}/comments`, {
      body,
      parentId,
    })
    .then((res) => res.data);

export const upvoteBookClubComment = (commentId) =>
  api.post(`/v1/community/comments/${commentId}/vote`).then((res) => res.data);

export const removeBookClubCommentVote = (commentId) =>
  api
    .delete(`/v1/community/comments/${commentId}/vote`)
    .then((res) => res.data);

export const reportCommunityContent = (targetType, targetId, reason) =>
  api
    .post("/v1/community/reports", { targetType, targetId, reason })
    .then((res) => res.data);

export const getAdminBookClubs = () =>
  api.get("/v1/admin/community/book-clubs").then((res) => res.data);

export const getAdminBookClub = (clubId) =>
  api.get(`/v1/admin/community/book-clubs/${clubId}`).then((res) => res.data);

const bookClubFormData = (club) => {
  const formData = new FormData();
  formData.append("title", club.title);
  formData.append("description", club.description);
  formData.append("starts_at", club.startsAt);
  formData.append("ends_at", club.endsAt);
  formData.append("published", club.published ? "1" : "0");
  if (club.coverFile) {
    formData.append("cover", club.coverFile);
  }
  formData.append("reading_order_id", club.readingOrderId);
  club.threads.forEach((thread, index) => {
    if (thread.id) {
      formData.append(`threads[${index}][id]`, thread.id);
    }
    formData.append(`threads[${index}][title]`, thread.title);
    formData.append(`threads[${index}][body]`, thread.body);
    if (thread.spoilerOrderPosition) {
      formData.append(
        `threads[${index}][spoiler_order_position]`,
        thread.spoilerOrderPosition
      );
    }
  });
  club.removedThreadIds.forEach((threadId) => {
    formData.append("removed_thread_ids[]", threadId);
  });
  return formData;
};

const multipartConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

export const createAdminBookClub = (club) =>
  api
    .post(
      "/v1/admin/community/book-clubs",
      bookClubFormData(club),
      multipartConfig
    )
    .then((res) => res.data);

export const updateAdminBookClub = (clubId, club) => {
  const formData = bookClubFormData(club);
  formData.append("_method", "PUT");
  return api
    .post(`/v1/admin/community/book-clubs/${clubId}`, formData, multipartConfig)
    .then((res) => res.data);
};

export const deleteAdminBookClub = (clubId) =>
  api
    .delete(`/v1/admin/community/book-clubs/${clubId}`)
    .then((res) => res.data);

export const getAdminCommunityReports = () =>
  api.get("/v1/admin/community/reports").then((res) => res.data);

export const updateAdminCommunityReport = (reportId, status) =>
  api
    .patch(`/v1/admin/community/reports/${reportId}`, { status })
    .then((res) => res.data);
